import css from "styled-jsx/css";
import colors from "styles/colors";

export const componentStyles = css.global`
  .cluster-selection-signup-item-component {
    position: absolute;
    top: 0;
    right: 0;
    bottom: 16px;
    left: 0;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    border: 3px solid;
    border-radius: 8px;
    background-color: white;
    box-shadow: 0px 4px 8px 0px rgba(0, 0, 0, 0.14);
    overflow: hidden;

    .close-icon-wrapper {
      position: absolute;
      top: 11px;
      right: 11px;
      padding: 5px;
      cursor: pointer;

      svg {
        height: 12px;
      }
    }

    .header {
      display: flex;
      align-items: center;

      .image {
        width: 30px;
        margin-right: 16px;
      }

      .title {
        font-size: 1.688rem;
        font-weight: 700;
      }
    }

    .signup-form-wrapper {
      margin-top: 24px;
    }

    .quote-component-wrapper {
      margin-top: 40px;
      padding: 0px 32px;

      .person-quote {
        font-size: 0.875rem !important;
        line-height: 22px !important;
      }

      .person-title {
        font-size: 0.8125rem !important;
      }

      .person-text-setcion {
        width: auto !important;
      }
    }
  }
`;
